module.exports = __webpack_public_path__ + "static/OpenSans-Regular-a725497524525c361f0d545e4e8ec577.woff2";